import { MARKUP_EVENT } from './constants';
import getCoordsOfMarkupSelection from './getCoordsOfMarkupSelection';
import showUserMarkupPopup from '../components/UserMarkupPopup';
import { ClientItem } from 'owa-mail-store';

export default function addUserMarkupPopupEventListener(
    element: HTMLElement,
    item: ClientItem,
    highlight: string,
    isForExistingUserNote: boolean,
    instance?: number
) {
    const UserMarkupPopupHandler = (event: MouseEvent) => {
        const boundingRects = element.getClientRects();
        showUserMarkupPopup(
            getCoordsOfMarkupSelection(boundingRects, highlight),
            highlight,
            element,
            item,
            !isForExistingUserNote /* isForExistingUserHighlight */,
            isForExistingUserNote,
            null /* selectionRange */,
            instance
        );
    };
    element.addEventListener('click', UserMarkupPopupHandler);
    element[MARKUP_EVENT] = UserMarkupPopupHandler;
}
